'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *
 */
var SET = exports.SET = 'vtech-chat/user/SET';

/**
 *
 */
var set = exports.set = function set(user) {
  return {
    type: SET,
    payload: {
      user: user
    }
  };
};